import { render } from "./LocationComponent.vue?vue&type=template&id=1cafeab6"
import script from "./LocationComponent.vue?vue&type=script&lang=js"
export * from "./LocationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__